import { useEffect, useState } from "react";
import { MessageCircle, Copy, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { tr, trServer } from "../lib/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const copyText = async (text) => {
  try { await navigator.clipboard.writeText(text); } catch {
    const ta = document.createElement("textarea");
    ta.value = text; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
  }
  toast.success(tr("share.copied"));
};

const defaultLang = () => (document.documentElement.dir === "rtl" ? "ar" : "en");

export default function ShareCarDialog({ vehicleId, open, onClose }) {
  const [lang, setLang] = useState(defaultLang());
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!open) return;
    setData(null); setErr("");
    api.get(`/vehicles/${vehicleId}/share`, { params: { lang, origin: window.location.origin } })
      .then(({ data: d }) => setData(d))
      .catch((e) => setErr(e?.response?.status === 409 ? tr("share.publish_first") : trServer(formatApiError(e))));
  }, [open, lang, vehicleId]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="share-dialog">
        <DialogHeader><DialogTitle>{tr("share.title")}</DialogTitle><DialogDescription>{tr("share.help")}</DialogDescription></DialogHeader>
        <div className="flex gap-1.5" data-testid="share-lang">
          {["en", "ar", "both"].map((l) => (
            <button key={l} type="button" onClick={() => setLang(l)} data-testid={`share-lang-${l}`}
              className={`px-3 py-1.5 text-xs font-semibold rounded-full border ${lang === l ? "bg-[var(--ink)] text-white border-[var(--ink)]" : "border-[var(--line)]"}`}>{tr(`sg.lang_${l /* i18n-keys: en,ar,both */}`)}</button>
          ))}
        </div>
        {err ? <p className="text-sm text-red-600 font-semibold" data-testid="share-error">{err}</p>
          : !data ? <Loader2 className="animate-spin" />
          : <pre dir="auto" className="text-sm whitespace-pre-wrap font-sans border border-[var(--line)] rounded-lg p-3 max-h-72 overflow-y-auto" data-testid="share-preview">{data.message}</pre>}
        <div className="flex flex-wrap justify-end gap-2">
          <button className="btn-secondary" disabled={!data} onClick={() => copyText(data.message)} data-testid="share-copy"><Copy size={14} /> {tr("share.copy")}</button>
          <a className={`btn-primary ${data ? "" : "pointer-events-none opacity-50"}`} href={data?.whatsapp_url || "#"} target="_blank" rel="noopener noreferrer" data-testid="share-whatsapp">
            <MessageCircle size={14} /> {tr("share.whatsapp")}
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
}
